import React from 'react';
import toast from 'react-hot-toast';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

// ##### SHOW CONFLICT TOAST - Display toast with action buttons
export const showConflictToast = (itemName, itemId, onResolve) => {
  const toastId = toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <ExclamationTriangleIcon className="h-6 w-6 text-orange-500" />
            </div>
            <div className="ml-3 w-0 flex-1">
              <p className="text-sm font-medium text-gray-900">Conflict Detected</p>
              <p className="mt-1 text-sm text-gray-500">
                Item <span className="font-semibold">{itemName}</span> was modified offline and online
              </p>
              <div className="mt-3 flex gap-2">
                <button
                  onClick={() => {
                    onResolve('client-wins');
                    toast.dismiss(t.id);
                  }}
                  className="flex-1 bg-blue-500 text-white text-xs px-3 py-1.5 rounded hover:bg-blue-600 transition-colors"
                >
                  My Data
                </button>
                <button
                  onClick={() => {
                    onResolve('server-wins');
                    toast.dismiss(t.id);
                  }}
                  className="flex-1 bg-gray-500 text-white text-xs px-3 py-1.5 rounded hover:bg-gray-600 transition-colors"
                >
                  Server
                </button>
                <button
                  onClick={() => {
                    onResolve('last-write-wins');
                    toast.dismiss(t.id);
                  }}
                  className="flex-1 bg-green-500 text-white text-xs px-3 py-1.5 rounded hover:bg-green-600 transition-colors"
                >
                  Latest
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex border-l border-gray-200">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            ×
          </button>
        </div>
      </div>
    ),
    {
      duration: 30000, // 30 seconds timeout
      position: 'top-right',
    }
  );

  return toastId;
};

export default showConflictToast;
